module.exports = __webpack_public_path__ + "img/67.2a30dea3.jpg";